var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.outcome && _vm.outcome.quotation && _vm.outcome.quotation.productResults)?_c('div',{staticClass:"spinner-container"},[_c('div',{staticClass:"spinner-background"}),_vm._m(0)]):_vm._e()])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"spinner"},[_c('div',{staticClass:"spinner-circle"})])
}]

export { render, staticRenderFns }